// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { IOcrContent } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";

/**
 * App Title Reducer
 * Actions handled:
 *  SET_TITLE
 * @param {string} state
 * @param {AnyAction} action
 * @returns {any}
 */
export const reducer = (state: IOcrContent[] = [], action: AnyAction): IOcrContent[] => {
    if (!state) {
        state = [];
    }
    switch (action.type) {
        case ActionTypes.LOAD_OCR_CONTENT_SUCCESS:
            return  [
                { ...action.payload },
                ...state.filter((ocrContent) => ocrContent.id !== action.payload.id),
            ];
        case ActionTypes.LOGGED_OUT_USER:
            return [];
        case ActionTypes.CLEAR_EXISTING_MODEL_OCR_FILES_SUCCESS:
                return [];
        default:
            return state;
    }
};
